var exports = {
  "Z": "asyncSuggestion__5hm4p0",
  "e": "stale__ishJGG",
};

module.exports = exports;
